module.exports = __webpack_public_path__ + "static/media/warning.048c27f6.svg";